// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ReturnSlipState from "@store/Framework/Store/Store/Pages/ReturnSlip/ReturnSlipState";
import { ReturnSlipModel } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ReturnSlipState = {
    isLoading: false,
    returnSlipsById: {},
};

const actions = {
    "Store/Pages/ReturnSlip/BeginLoadReturnSlip": (draft: Draft<ReturnSlipState>, action: { returnSlipId: string }) => {
        draft.isLoading = true;
        draft.returnSlipId = action.returnSlipId;
    },
    "Store/Pages/ReturnSlip/FailedToLoadReturnSlip": (draft: Draft<ReturnSlipState>, action: {}) => {
        draft.failedToLoadReturnSlip = true;
        draft.isLoading = false;
    },
    "Store/Pages/ReturnSlip/CompleteLoadReturnSlip": (
        draft: Draft<ReturnSlipState>,
        action: { model: ReturnSlipModel },
    ) => {
        draft.returnSlipsById[action.model.id] = action.model;

        draft.isLoading = false;
        delete draft.failedToLoadReturnSlip;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreReturnSlipActions = Parameters<typeof reducer>[1];
export default reducer;
